let vsplAjax = {
  isEmail(email) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return email.match(mailformat) ? true : false;
  },
  phonenumber(inputtxt) {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  },

  newsLetter() {
    /**
     * Subscribe to Our Newsletter
     */
    const forms = document.querySelectorAll(".newsletter-form");

    if (forms.length === 0) return; // Exit if no forms exist on the page

    forms.forEach(form => {
      const nameInput = form.querySelector("[data-element='newslettername']");
      const emailInput = form.querySelector("[data-element='newsletteremail']");
      const messageBox = form.nextElementSibling; // Ensure message box is related to the form

      if (!nameInput || !emailInput || !messageBox) return; // Prevent errors if elements are missing

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        let isValid = true;

        // Reset previous error states
        [nameInput, emailInput].forEach(input => input.classList.remove("error"));

        // Name validation
        if (nameInput.value.trim().length < 2) {
          nameInput.classList.add("error");
          isValid = false;
        }

        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailInput.value.trim())) {
          emailInput.classList.add("error");
          isValid = false;
        }

        if (!isValid) return; // Stop if validation fails

        // Prepare form data
        const formData = new FormData();
        formData.append("action", "vspl_newsletter_subscribe"); // WordPress AJAX action
        formData.append("security", vspl.security); // Nonce for security
        formData.append("name", nameInput.value.trim());
        formData.append("email", emailInput.value.trim());

        // AJAX Submission
        fetch(vspl.ajaxurl, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        })
          .then(response => response.json()) // Convert response to JSON
          .then(data => {
            if (data.success) {
              messageBox.textContent = data.message || "You’re subscribed! Get ready for stories that uplift and inspire.";
              messageBox.hidden = false;
              form.reset();
            } else {
              messageBox.textContent = data.message || "Subscription failed. Please try again.";
              messageBox.hidden = false;
            }
          })
          .catch(error => {
            console.error("Fetch error:", error); // Log error for debugging
            messageBox.textContent = "An error occurred. Please try again later.";
            messageBox.hidden = false;
          });
      });
    });
  },
  contactUs() {
    if (jQuery('.vspl__contactUs').length > 0) {
      jQuery(document).on('click', '[data-contact="submit"]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        jQuery('.vspl__contact--field').removeClass('vspl__error');

        let txtName = jQuery.trim(
          jQuery('#vspl__contact--form #txtname').val()
        );
        let txtEmail = jQuery.trim(
          jQuery('#vspl__contact--form #txtemail').val()
        );
        let txtMessage = jQuery.trim(
          jQuery('#vspl__contact--form #txtmessage').val()
        );
        let txtphone = jQuery.trim(
          jQuery('#vspl__contact--form #txtphone').val()
        );
        let isValid = true;

        if (txtName.length < 3) {
          isValid = false;
          jQuery('#vspl__contact--form #txtname').addClass('vspl__error');
        }

        if (vsplAjax.isEmail(txtEmail) == false) {
          isValid = false;
          jQuery('#vspl__contact--form #txtemail').addClass('vspl__error');
        }

        if (vsplAjax.phonenumber(txtphone) == false) {
          isValid = false;
          jQuery('#vspl__contact--form #txtphone').addClass('vspl__error');
        }

        if (txtMessage.length < 10) {
          isValid = false;
          jQuery('#vspl__contact--form #txtmessage').addClass('vspl__error');
        }


        if (isValid == true) {
          jQuery('[data-contact="submit"]').prop('disabled', true);
          jQuery.ajax({
            url: vspl.ajaxurl,
            type: 'post',
            data: {
              action: 'vspl__contact',
              security: vspl.security,
              name: txtName,
              email: txtEmail,
              phone: txtphone,
              message: txtMessage,
            },
            success(data) {
              jQuery('#vspl__contact--form').trigger("reset");
              jQuery('[data-contact="message"]').html(`<p>${data}</p>`);
              dataLayersWP.contactForm();
            },
          });
        } else {
          return false;
        }
      });
    }
  },

  productNewsLetter() {
    /**
     * Subscribe to Our Newsletter
     */
    if (jQuery('[data-element="pnewsletteremail"]').length > 0) {
      jQuery(document).on('click', '[data-element="psubscribe"]', function (e) {
        e.preventDefault();

        let email = jQuery('[data-element="pnewsletteremail"]').val();

        if (!!email !== false) {
          jQuery.ajax({
            url: vspl.ajaxurl,
            type: 'post',
            data: {
              action: 'vspl__product_newsletter',
              security: vspl.security,
              email: email,
            },
            success(data) {
              jQuery('[data-element="pnewsletteremail"]').val('');
              jQuery('[data-pnewsletter="message"]').text(data);
            },
          });
        }
      });
    }
  },
  requestOtp() {
    jQuery(document).on('click', '[data-action="requestotp"]', function () {
      let email = jQuery('#vspl__uad--form #txtemail').val();

      if (vsplAjax.isEmail(email) !== false) {
        jQuery.ajax({
          url: vspl.ajaxurl,
          type: 'post',
          data: {
            action: 'vspl__uad_requestotp',
            security: vspl.security,
            email: email,
          },
          success(data) {
            jQuery('[data-uad="message"]').text(data.msg);
            if (data.status == 'success') {
              jQuery('#vspl__uad--form #txtemail').prop('readonly', true);
              jQuery('#vspl__uad--form #txtemail').prop('disabled', true);
              jQuery('[data-action="requestotp"]').hide();
              jQuery('#otpsection').show();
              jQuery('[data-action="requestaccountdelete"]').show();
            }
          },
        });
      } else {
        jQuery('#vspl__uad--form #txtemail').addClass('vspl__error');
      }
    });
  },
  requestAccountDelete() {
    jQuery(document).on('click', '[data-action="requestaccountdelete"]', function () {
      let txtotp = jQuery('#vspl__uad--form #txtotp').val();

      if ((!!txtotp !== false) && (txtotp.length > 4)) {
        jQuery.ajax({
          url: vspl.ajaxurl,
          type: 'post',
          data: {
            action: 'vspl__uad_confirm',
            security: vspl.security,
            txtotp: txtotp,
          },
          success(data) {
            jQuery('[data-uad="message"]').text(data.msg);

            if (data.status == 'success') {
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          },
        });
      } else {
        jQuery('#vspl__uad--form #txtotp').addClass('vspl__error');
      }
    }
    );
  },
  init() {
    this.newsLetter();
    this.contactUs();
    this.productNewsLetter();

    if (jQuery('#vspl__uad--form').length > 0) {
      this.requestOtp();
      this.requestAccountDelete();
    }
  },
};
